import React from 'react';
import { ConfigProvider } from 'antd';
import { UserProvider } from './context/UserContext';
import AppRouter from './router';
import './App.css';
import './styles/global.css';
import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
        },
      }}
    >
      <UserProvider>
        <div className="App app-container">
          <AppRouter />
        </div>
      </UserProvider>
    </ConfigProvider>
  );
}

export default App;
